export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  image: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  views: number;
}

export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'juqing', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-palette-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: 'kehuan',
    year: 2026,
    rating: 9.2,
    duration: '148分钟',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳急速老化，持续膨胀。地球面临被太阳吞噬的危机。为了生存，人类提出一个名为"流浪地球"的大胆计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，用2500年的时间奔往另外一个栖息之地...',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20movie%20poster%20featuring%20a%20massive%20planet%20Earth%20with%20glowing%20engines%20in%20deep%20space%2C%20dramatic%20lighting%2C%20orange%20and%20blue%20color%20scheme%2C%20epic%20scale%2C%20Chinese%20sci-fi%20aesthetic%2C%20movie%20poster%20style%20with%20clean%20composition%2C%20dark%20background%20with%20stars%2C%20cinematic%20quality&width=800&height=1120&seq=movie-wandering-earth-3&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['IMAX', '3D', '国语'],
    views: 12580000,
  },
  {
    id: 2,
    title: '红海行动2：蛟龙出击',
    titleEn: 'Operation Red Sea 2',
    category: 'dongzuo',
    year: 2026,
    rating: 8.9,
    duration: '138分钟',
    region: '中国大陆',
    director: '林超贤',
    actors: ['张译', '黄景瑜', '海清'],
    description: '蛟龙突击队再次出击，面对更加复杂的国际局势和更加危险的敌人，他们必须用自己的勇气和智慧，捍卫国家的尊严和人民的安全。一场惊心动魄的海外救援行动即将展开...',
    image: 'https://readdy.ai/api/search-image?query=A%20military%20action%20movie%20poster%20with%20soldiers%20in%20tactical%20gear%20on%20a%20warship%2C%20explosive%20background%20with%20fire%20and%20smoke%2C%20dramatic%20cinematic%20lighting%2C%20red%20and%20dark%20tones%2C%20modern%20Chinese%20military%20film%20poster%20design%2C%20clean%20composition&width=800&height=1120&seq=movie-red-sea-2&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['IMAX', '国语', '军事'],
    views: 10230000,
  },
  {
    id: 3,
    title: '长安三万里2',
    titleEn: 'Chang An 2',
    category: 'donghua',
    year: 2026,
    rating: 9.0,
    duration: '168分钟',
    region: '中国大陆',
    director: '追光动画',
    actors: ['杨天翔', '凌振赫'],
    description: '继第一部讲述李白与高适的故事之后，第二部将聚焦杜甫的传奇人生。在安史之乱的动荡年代，诗圣杜甫用他的笔记录下了那个时代最真实的写照，谱写了一段荡气回肠的史诗...',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20animated%20film%20poster%20featuring%20ancient%20Tang%20Dynasty%20landscape%20with%20traditional%20Chinese%20architecture%2C%20poetic%20atmosphere%2C%20warm%20golden%20and%20red%20color%20palette%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20artistic%20movie%20poster&width=800&height=1120&seq=movie-changan-2&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['国产动画', '历史', '国语'],
    views: 8900000,
  },
  {
    id: 4,
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    category: 'dongzuo',
    year: 2026,
    rating: 8.7,
    duration: '150分钟',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    description: '封神大战进入白热化阶段，姜子牙率领的西岐大军与纣王的商朝大军展开终极对决。神仙妖魔纷纷登场，一场关乎天下苍生命运的大战即将上演...',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20dramatic%20golden%20and%20crimson%20color%20scheme%2C%20grand%20battle%20scene%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20quality%2C%20clean%20poster%20composition&width=800&height=1120&seq=movie-fengshen-2&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['IMAX', '3D', '国语'],
    views: 9800000,
  },
  {
    id: 5,
    title: '热辣滚烫2',
    titleEn: 'YOLO 2',
    category: 'xiju',
    year: 2026,
    rating: 8.5,
    duration: '129分钟',
    region: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    description: '乐莹在拳击赛场上找到了自信之后，开始了全新的人生旅程。这一次，她将面对事业和爱情的双重挑战，用幽默和温暖的态度，继续书写属于自己的精彩人生...',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20inspiring%20Chinese%20comedy%20movie%20poster%20with%20a%20confident%20woman%20in%20boxing%20gloves%2C%20bright%20and%20energetic%20color%20palette%2C%20cheerful%20atmosphere%2C%20modern%20Chinese%20film%20poster%20design%2C%20clean%20composition%2C%20motivational%20vibe&width=800&height=1120&seq=movie-yolo-2&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['喜剧', '励志', '国语'],
    views: 7600000,
  },
  {
    id: 6,
    title: '深海2',
    titleEn: 'Deep Sea 2',
    category: 'donghua',
    year: 2026,
    rating: 8.8,
    duration: '115分钟',
    region: '中国大陆',
    director: '田晓鹏',
    actors: ['未知'],
    description: '继第一部的深海奇幻之旅后，参宿再次进入那个神秘的水下世界。这一次，她将探索更深处的海洋秘密，遇见更多奇妙的生物，揭开深海旅馆背后隐藏的真相...',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20animated%20film%20poster%20with%20deep%20ocean%20scenery%2C%20colorful%20sea%20creatures%20and%20bioluminescent%20effects%2C%20dreamy%20underwater%20atmosphere%2C%20vibrant%20blue%20and%20purple%20color%20palette%2C%20artistic%20movie%20poster%20design%2C%20magical%20and%20mysterious%20vibe&width=800&height=1120&seq=movie-deep-sea-2&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['国产动画', '奇幻', '国语'],
    views: 6700000,
  },
  {
    id: 7,
    title: '消失的她2',
    titleEn: 'Lost in the Stars 2',
    category: 'xuanyi',
    year: 2026,
    rating: 8.4,
    duration: '122分钟',
    region: '中国大陆',
    director: '陈思诚',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    description: '何非本以为一切已经结束，但一个神秘的包裹让他再次陷入了新的谜局。这一次，谜团更加复杂，真相更加扑朔迷离。当所有人都可能是嫌疑人时，信任成了最奢侈的东西...',
    image: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20Chinese%20thriller%20movie%20poster%20with%20a%20mysterious%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20intriguing%20visual%20elements%2C%20modern%20noir%20aesthetic%2C%20Chinese%20film%20poster%20style%2C%20clean%20composition%2C%20enigmatic%20vibe&width=800&height=1120&seq=movie-lost-stars-2&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['悬疑', '犯罪', '国语'],
    views: 8200000,
  },
  {
    id: 8,
    title: '飞驰人生3',
    titleEn: 'Pegasus 3',
    category: 'xiju',
    year: 2026,
    rating: 8.3,
    duration: '125分钟',
    region: '中国大陆',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正'],
    description: '张驰再次回到赛道，这一次他要挑战的是国际顶级的拉力赛。面对更强大的对手和更艰难的赛道，他和他的团队将用热血和欢笑，诠释什么是真正的飞驰人生...',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20racing%20comedy%20movie%20poster%20with%20a%20rally%20car%20in%20action%2C%20dust%20and%20speed%20effects%2C%20dramatic%20desert%20background%2C%20warm%20and%20energetic%20color%20palette%2C%20modern%20Chinese%20film%20poster%2C%20dynamic%20composition&width=800&height=1120&seq=movie-pegasus-3&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '赛车', '国语'],
    views: 7100000,
  },
  {
    id: 9,
    title: '志愿军：存亡之战',
    titleEn: 'The Volunteers: Battle of Life and Death',
    category: 'zhanzheng',
    year: 2026,
    rating: 9.1,
    duration: '156分钟',
    region: '中国大陆',
    director: '陈凯歌',
    actors: ['张颂文', '魏大勋', '章子怡'],
    description: '抗美援朝战争中最为惨烈的战役之一。志愿军战士们面对装备精良的敌军，用血肉之躯筑起了保卫国家的钢铁长城。这是一场关乎存亡的战斗，更是一曲英雄主义的壮歌...',
    image: 'https://readdy.ai/api/search-image?query=A%20powerful%20Chinese%20war%20film%20poster%20with%20soldiers%20in%20battle%2C%20dramatic%20winter%20battlefield%20scene%2C%20heroic%20atmosphere%2C%20muted%20and%20solemn%20color%20palette%2C%20Chinese%20war%20movie%20poster%20design%2C%20epic%20and%20emotional%20composition&width=800&height=1120&seq=movie-volunteers-2&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['战争', '历史', '国语'],
    views: 11500000,
  },
  {
    id: 10,
    title: '星际穿越2',
    titleEn: 'Interstellar 2',
    category: 'kehuan',
    year: 2026,
    rating: 9.3,
    duration: '169分钟',
    region: '美国',
    director: '克里斯托弗·诺兰',
    actors: ['马修·麦康纳', '安妮·海瑟薇'],
    description: '库珀穿越虫洞之后，在五维空间中发现了改变人类命运的关键信息。人类在新的星球上艰难求生，但一个更加惊人的发现将彻底改变他们对宇宙的认知...',
    image: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20sci-fi%20movie%20poster%20with%20a%20massive%20black%20hole%20and%20spaceship%2C%20deep%20space%20background%20with%20stars%20and%20nebula%2C%20cinematic%20epic%20scale%2C%20dramatic%20lighting%2C%20modern%20Hollywood%20film%20poster%20style%2C%20clean%20composition&width=800&height=1120&seq=movie-interstellar-2&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['IMAX', '原版', '字幕'],
    views: 13200000,
  },
  {
    id: 11,
    title: '你想活出怎样的人生',
    titleEn: 'The Boy and the Heron',
    category: 'donghua',
    year: 2024,
    rating: 8.6,
    duration: '124分钟',
    region: '日本',
    director: '宫崎骏',
    actors: ['山时聪真', '菅田将晖'],
    description: '少年真人在母亲去世后，跟随父亲搬到乡下。一只会说话的苍鹭将他引入了一个神秘的世界。在这个奇幻的世界里，真人经历了一场关于生命、死亡和成长的深刻旅程...',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Studio%20Ghibli%20style%20animated%20movie%20poster%20with%20a%20boy%20and%20a%20heron%20in%20a%20magical%20landscape%2C%20soft%20watercolor%20aesthetic%2C%20dreamy%20atmosphere%2C%20warm%20and%20nostalgic%20color%20palette%2C%20hand-drawn%20animation%20style%2C%20clean%20composition&width=800&height=1120&seq=movie-boy-heron&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['宫崎骏', '动画', '日语'],
    views: 5600000,
  },
  {
    id: 12,
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: 'juqing',
    year: 2023,
    rating: 8.9,
    duration: '180分钟',
    region: '美国',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特'],
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事，以及战后他在政治迫害中的挣扎与反思...',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20historical%20biopic%20movie%20poster%20with%20a%20man%20silhouette%20against%20a%20mushroom%20cloud%20explosion%2C%20black%20and%20white%20with%20orange%20fire%2C%20intense%20cinematic%20atmosphere%2C%20Hollywood%20film%20poster%20style%2C%20clean%20composition&width=800&height=1120&seq=movie-oppenheimer&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['传记', '历史', '原版'],
    views: 9400000,
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  return movies.filter((m) => m.category === categorySlug);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter((m) => m.isNew);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};